module.exports = __webpack_public_path__ + "static/media/5.edd8a64f.svg";